import { useForm, Head, Link } from '@inertiajs/react';

export default function ResetPassword({ errors, token }) {
  const { data, setData, patch, processing } = useForm({
    password: '',
    password_confirmation: '',
    token: token,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    patch('/reset_password'); // This will hit your passwords#update action
  };

  return (
    <>
      <Head title='Reset Password' />
      <div className='min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8'>
        <div className='max-w-md w-full space-y-8'>
          <div>
            <h2 className='mt-6 text-center text-3xl font-extrabold text-gray-900'>
              Reset your password
            </h2>
          </div>

          <form className='mt-8 space-y-6' onSubmit={handleSubmit}>
            <div className='rounded-md shadow-sm -space-y-px'>
              <div>
                <label htmlFor='password' className='sr-only'>
                  New Password
                </label>
                <input
                  id='password'
                  name='password'
                  type='password'
                  autoComplete='new-password'
                  required
                  className='appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-[var(--color-yellow-primary)] focus:border-[var(--color-yellow-primary)] focus:z-10 sm:text-sm'
                  placeholder='New Password'
                  value={data.password}
                  onChange={(e) => setData('password', e.target.value)}
                />
              </div>
              <div>
                <label htmlFor='password-confirmation' className='sr-only'>
                  Confirm Password
                </label>
                <input
                  id='password-confirmation'
                  name='password_confirmation'
                  type='password'
                  autoComplete='new-password'
                  required
                  className='appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-[var(--color-yellow-primary)] focus:border-[var(--color-yellow-primary)] focus:z-10 sm:text-sm'
                  placeholder='Confirm Password'
                  value={data.password_confirmation}
                  onChange={(e) =>
                    setData('password_confirmation', e.target.value)
                  }
                />
              </div>
            </div>

            {errors.password && (
              <div className='text-red-500 text-sm'>{errors.password}</div>
            )}
            {errors.password_confirmation && (
              <div className='text-red-500 text-sm'>
                {errors.password_confirmation}
              </div>
            )}

            <div>
              <button
                type='submit'
                className='group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-slate-900 bg-[var(--color-yellow-primary)] hover:bg-[var(--color-yellow-secondary)] hover:text-slate-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[var(--color-yellow-primary)]'
                disabled={processing}
              >
                Reset Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
